import React from 'react';
import { Input, FormGroup, Label } from 'reactstrap';
import PropTypes from 'prop-types';
import StyledFormLabel from 'components/form/StyledFormLabel';
import { DateFormats } from 'utils/teamHelper';
import Tooltip, {
  tooltipPropTypes,
  getTooltipTarget
} from 'components/Tooltip';

const formats = DateFormats;

const { MDY, DMY, YMD } = formats;

function DateFormatInput({ value, onChange, tooltipProps }) {
  return (
    <React.Fragment>
      <FormGroup check>
        <Tooltip {...tooltipProps} />
        <StyledFormLabel {...getTooltipTarget(tooltipProps)}>
          Date Format
        </StyledFormLabel>
        <br />
        <Label check>
          <Input
            onClick={() => onChange(MDY)}
            type="radio"
            name={MDY}
            checked={!value || value === MDY}
          />
          {MDY}
        </Label>
        <br />
        <Label check>
          <Input
            onClick={() => onChange(DMY)}
            type="radio"
            name={DMY}
            checked={value === DMY}
          />
          {DMY}
        </Label>
        <br />
        <Label check>
          <Input
            onClick={() => onChange(YMD)}
            type="radio"
            name={YMD}
            checked={value === YMD}
          />
          {YMD}
        </Label>
      </FormGroup>
    </React.Fragment>
  );
}

DateFormatInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  tooltipProps: PropTypes.shape(tooltipPropTypes)
};

export default DateFormatInput;
